import { subscriptionConstants } from "../actions/constants/subscriptionConstants";

// Get Subscription Plan Reducer
const initialGetPlanState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

export const getSubscriptionPlanReducer = (state = initialGetPlanState, action: any) => {
  switch (action.type) {
    case subscriptionConstants.getSubscriptionPlanRequest:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case subscriptionConstants.getSubscriptionPlanSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload,
      };
    case subscriptionConstants.getSubscriptionPlanFailure:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

// Create Subscription Reducer
const initialCreateSubscriptionState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

export const createSubscriptionReducer = (state = initialCreateSubscriptionState, action: any) => {
  switch (action.type) {
    case subscriptionConstants.createSubscriptionRequest:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case subscriptionConstants.createSubscriptionSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload,
      };
    case subscriptionConstants.createSubscriptionFailure:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

// Get Subscription Status Reducer
const initialSubscriptionStatusState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};



export const subscriptionStatusReducer = (state = initialSubscriptionStatusState, action: any) => {
  switch (action.type) {
    case subscriptionConstants.getSubscriptionStatusRequest:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case subscriptionConstants.getSubscriptionStatusSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload,
      };
    case subscriptionConstants.getSubscriptionStatusFailure:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

// Get Order Status Reducer
const initialOrderStatusState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

export const orderStatusReducer = (state = initialOrderStatusState, action: any) => {
  switch (action.type) {
    case subscriptionConstants.getOrderStatusRequest:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case subscriptionConstants.getOrderStatusSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload,
      };
    case subscriptionConstants.getOrderStatusFailure:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

// Sync Plans Reducer
const initialSyncPlansState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

export const syncPlansReducer = (state = initialSyncPlansState, action: any) => {
  switch (action.type) {
    case subscriptionConstants.syncPlansRequest:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case subscriptionConstants.syncPlansSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload,
      };
    case subscriptionConstants.syncPlansFailure:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};


export const getAllPlansReducer = (state = initialGetPlanState, action: any) => {
  switch (action.type) {
    case subscriptionConstants.getAllPlansRequest:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case subscriptionConstants.getAllPlansSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload,
      };
    case subscriptionConstants.getAllPlansFailure:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

// User Subscription Status Reducer
interface UserSubscriptionStatusState {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  data: {
    hasSubscription: boolean;
    subscriptionId?: string;
    planId?: string;
    planName?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    isExpired?: boolean;
    isExpiringSoon?: boolean;
    daysRemaining?: number | null;
    message?: string;
    limits?: {
      maxStudents?: number | null;
      maxInstructors?: number | null;
      storageLimit?: number | null;
    };
    routes?: string[];
  } | null;
  error: any;
}

const initialUserSubscriptionStatusState: UserSubscriptionStatusState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

export const userSubscriptionStatusReducer = (
  state = initialUserSubscriptionStatusState,
  action: any
): UserSubscriptionStatusState => {
  switch (action.type) {
    case subscriptionConstants.getUserSubscriptionStatusRequest:
      return {
        ...state,
        isLoading: true,
        isSuccess: false,
        isError: false,
        error: null,
      };
    case subscriptionConstants.getUserSubscriptionStatusSuccess:
      return {
        ...state,
        isLoading: false,
        isSuccess: true,
        data: action.payload,
      };
    case subscriptionConstants.getUserSubscriptionStatusFailure:
      return {
        ...state,
        isLoading: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};